// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeatureBand_wrapper__m_T67","mediaWrapper":"FeatureBand_mediaWrapper__KhuiP","image":"FeatureBand_image__4m2Xb","video":"FeatureBand_video__AeAIp"};